import React from 'react';
import {Link} from 'react-router-dom';
import './Product-Link.css';

const ProductLink = props => {

    console.log(props);

    return (
    <div  className="Product-Link">
        {!props.IsSoldOut &&
        
        <Link
            to={'/Products/Create/' + props.text}
        >
            <img src={props.pic} className="Product-Pic" style={{width: '100%'}}/>

            <div className='Product-Text'>
                {props.text}
                <br />
                <b>
                ${props.Price.toFixed(2)} 
                </b>
            </div>
        </Link>
        }

        {props.IsSoldOut &&
            <div className="Product-Links">
                <img className='Sold-Out' src='https://api.caigoycreations.com/content/img/sold-out.png' />
                <img src={props.pic} className="Product-Pic" style={{width: '100%'}}/>
                <div className='Product-Text'>
                    {props.text}
                    <br />
                    <b>
                        ${props.Price.toFixed(2)} 
                    </b>
                </div>
                
            </div>
        }
    </div>
    )
    
    };

export default ProductLink;